interface planParams {
  name: string;
  price: number;
  description: string;
  allowedNumberOfBranches: number;
  contactOnly: boolean;
}
export const planValidate = ({
  name,
  price,
  description,
  allowedNumberOfBranches,
  contactOnly,
}: planParams): any => {
  const errors: any = {};
  if (!name) {
    errors.name = "* Required";
  }

  if (!description) {
    errors.description = "* Required";
  }

  if (!allowedNumberOfBranches) {
    errors.allowedNumberOfBranches = "* Required";
  }

  // Contact-only plans (e.g. Enterprise) have no price.
  if (!contactOnly && !price) {
    errors.price = "* Required";
  }

  return errors;
};
